import React from 'react';
import { Box, Button, HStack, Heading, useColorModeValue } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { AddIcon } from '@chakra-ui/icons';
import PollsList from './PollsList';
import Breadcrumbs from './shared/Breadcrumbs';

function PollsPage() {
  const bgColor = useColorModeValue('background.shade1', 'background.shade3');

  return (
    <Box className="polls-page" bg={bgColor} minHeight="100vh">
      <Box maxWidth="800px" margin="0 auto" px={4} py={8}>
        <Breadcrumbs
          items={[
            { label: 'Home', path: '/' },
            { label: 'Polls' }
          ]}
        />
        <HStack justify="space-between" mb={6}>
          <Heading as="h1" size="lg">Polls</Heading>
          <Button
            as={ReactRouterLink}
            to="/polls/new"
            leftIcon={<AddIcon />}
            colorScheme="teal"
          >
            New Poll
          </Button>
        </HStack>
        <PollsList />
      </Box>
    </Box>
  );
}

export default PollsPage;